import { useSelector } from 'react-redux'
import { token, userId, userInfo } from './selectors'

export const useToken = () => useSelector(token)
export const useUserInfo = () => useSelector(userInfo)
export const useUserId = () => useSelector(userId)

const ROOT_USERNAME = 'root'

/**
 * True once `userInfo` has loaded AND belongs to the `root` user; false
 * while loading or for any other user. Gates features still being rolled
 * out (custom dashboards, list filter pills and saved views).
 */
export const useIsRootUser = () => useUserInfo()?.username === ROOT_USERNAME
